import { Outlet } from 'react-router-dom';
import { AppProviders } from '../contexts';

/**
 * Root application layout. Wraps the entire authenticated experience with
 * every payment-domain context provider.
 */
export default function RootLayout() {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}
